"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
const ca_state_1 = require("./ca-state");
const us_state_1 = require("./us-state");
exports.PricingQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    haulerID: typebox_1.Type.String(),
    state: typebox_1.Type.Union([us_state_1.UsStateAbbreviation, ca_state_1.CAProvinceAbbreviation]),
    public: typebox_1.Type.Boolean(),
    active: typebox_1.Type.Boolean(),
    noJoins: typebox_1.Type.Boolean(),
}));
//# sourceMappingURL=pricing-query.js.map